import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, REQUEST_CONTEXT, inject } from '@angular/core';

import { filter } from 'rxjs';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { WindowEvent } from '../browser/window/window-ref.service';
import { WINDOW } from '../browser/window/window.token';
import { Page } from '../client-config/page.client-config';
import { ProductService } from '../products/product.service';
import { RemoteLogger, defaultRemoteLogger } from './remote-logger';

@Injectable()
export class LoggingBootstrapService implements OnAppInit {
    readonly #window = inject(WINDOW);
    private readonly page = inject(Page);
    private readonly productService = inject(ProductService);
    private readonly requestContext = inject<{ [key: string]: any }>(REQUEST_CONTEXT);
    private readonly isServer = isPlatformServer(inject(PLATFORM_ID));

    onAppInit() {
        const loggingConfig = this.page.logging;
        const disableLogLevels: { [key: string]: RegExp | null } = {};
        if (loggingConfig.disableLogLevels) {
            Object.entries(loggingConfig.disableLogLevels).forEach(([key, value]) => {
                disableLogLevels[key.toLowerCase()] = value ? new RegExp(value.pattern) : null;
            });
        }

        const loggerConfig = {
            isEnabled: loggingConfig.isEnabled,
            url: `${this.requestContext?.['host'] ?? ''}/log`,
            debounceInterval: this.isServer ? 100 : loggingConfig.debounceInterval,
            maxErrorsPerBatch: loggingConfig.maxErrorsPerBatch,
            disableLogLevels,
            hostProduct: this.page.product,
        };

        RemoteLogger.configure(loggerConfig);

        if (this.productService.isSingleDomainApp) {
            this.productService.productChanged.pipe(filter(({ name }) => name !== 'host')).subscribe(({ name }) => {
                loggerConfig.hostProduct = name;
                RemoteLogger.configure(loggerConfig);
            });
        }

        this.#window.addEventListener(WindowEvent.BeforeUnload, () => defaultRemoteLogger.sendLogsWithBeacon(), false);
    }
}
